import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';

import Whychooseimg03 from '../../assets/images/will-old.png';

const Whychoosetwo = () => {
    useEffect(() => {
        const handleScroll = () => {
            const elements = document.querySelectorAll(
                '.why-choose-two-image'
            );

            elements.forEach((el) => {
                const elementTop = el.getBoundingClientRect().top;
                const elementBottom = el.getBoundingClientRect().bottom;
                const viewportTop = 0;
                const viewportBottom = window.innerHeight;

                if (elementBottom > viewportTop && elementTop < viewportBottom) {
                    el.classList.add('active');
                }
            });
        };


        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    });
   
    return (
        <div className="why-choose-two" style={{background: "#f2f4f8"}}>
            
            <div className="container" id='about-will'>
                <div className="row gutter-y-30">
                    <div className="col-lg-7 align-self-center">
                        <div className="why-choose-right-two">
                            <div className="heading-box heading-white">
                                
                                <h2 className="heading-title wow fadeInUp animated animated text-black">
                                At The NRI Advisors, we make it simple.
                                </h2>
                            </div>
                            <p>
                            Our expert team helps NRIs like you legally execute your Will in India — without booking a flight ticket. We guide you through every step remotely with full legal compliance, confidentiality, and peace of mind. We understand the value of your time, legacy, and your loved ones. That’s why we have built a process that’s seamless, secure, and fully tailored to NRIs like you.
                            </p>
                           
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className="why-choose-two-image">
                            <img
                                src={Whychooseimg03} alt="why-choose-image"
                            />
                            <div className="image-shape">
                                <span />
                                <span />
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-12 mt-5">
                        <div className="row gutter-y-30">
                            {whychoosedata.map((data, index) =>
                                <div key={index}
                                    className="col-lg-4" >
                                    <div className="why-choose-two-box">
                                        <i className="flaticon-transparency" />
                                        <div className="why-choose-two-box-info">
                                            <h4>{data.heading}</h4>
                                            <p>
                                                {data.about}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div> */}
                </div>
            </div>
        </div >


    )
}
export default Whychoosetwo;